import {Math as MathUtils, PerspectiveCamera, Object3D, Vector3, Box3} from 'three';
import {component} from 'bidello';
import OrbitControls from 'orbit-controls-es6';
import renderer from './renderer';
import * as THREE from 'three';
import TWEEN from 'three/examples/jsm/libs/tween.module.min';
import {distanceToFitObjectToView} from './utils/position';

class Camera extends component(PerspectiveCamera) {
    constructor() {
        super(35, 0, 1, 50000);
        //super(35, 0, 0.01, 50000000000000);
    }

    init() {
        this.originalPosition = new Vector3().copy(this.position.set(0, 0, 10));
        this.lookAt(new Vector3(0, 0, 0));
        this.controls = this.initOrbitControl();

    }

    reset(){

        this.position.set(0, 0, 10);
        this.lookAt(new Vector3(0, 0, 0));
        this.controls.target = new Vector3(0, 0, 0);

    }

    initOrbitControl() {
        const controls = new OrbitControls(this, renderer.domElement);
        //controls.enabled = false;
        controls.maxDistance = 30000;
        controls.minDistance = 0;

        return controls;
    }

    calculateUnitSize(distance = this.position.z) {
        const vFov = this.fov * Math.PI / 180;
        const height = 2 * Math.tan(vFov / 2) * distance;
        const width = height * this.aspect;

        return {
            width,
            height
        };
    }

    getMaxViewportUnitSize (distance = this.position.z){

        const sizes = this.calculateUnitSize(distance);
        return Math.max(sizes.width,sizes.height);

    }

    getMinViewportUnitSize (distance = this.position.z){

        const sizes = this.calculateUnitSize(distance);
        return Math.min(sizes.width,sizes.height);

    }

    tweenCameraPosition(position,time=700) {

        return new TWEEN.Tween(this.position)
            .to({x: position.x, y: position.y, z: position.z}, time)
            .easing(TWEEN.Easing.Exponential.InOut)
            .onUpdate(() => {


            }).start()


    }

    tweenLookAtPosition(position,time=700) {

        this.controls.update();
        return new TWEEN.Tween(this.controls.target)
            .to({x: position.x, y: position.y, z: position.z}, time)
            .easing(TWEEN.Easing.Exponential.InOut)
            .onUpdate(() => {

                this.controls.update();

            }).start()


    }

    getCameraPosWithDistanceToSelection(selection, fitOffset = 1, refPoint = new Vector3()) {

        const box = new Box3();
        for (const object of selection) box.expandByObject(object);
        const size = box.getSize(new Vector3());
        const center = box.getCenter(new Vector3());
        const maxSize = Math.max(size.x, size.y, size.z);
        const fitHeightDistance = maxSize / (2 * Math.atan(Math.PI * this.fov / 360));
        const fitWidthDistance = fitHeightDistance / this.aspect;
        const distance = fitOffset * Math.max(fitHeightDistance, fitWidthDistance);
        const test = refPoint.clone();
        return refPoint.setZ(test.z + distance);

    }

    onResize({ratio}) {
        this.aspect = ratio;
        this.unit = this.calculateUnitSize();
        this.updateProjectionMatrix();
    }
}

export default new Camera();
